module.exports = __webpack_public_path__ + "static/media/modernHirePassed.ba5b73c0.svg";